import { IConClose } from "@components";
import { Divider } from "antd";
import { format } from "date-fns";
import { useFullScreen } from "src/Helpers/useFullscreen";
import styled from "styled-components";
import { PinIcon } from "../icon/Pin";

interface IProps {
    onClose: () => void;
    data: any;
}
export default function PopupDeviceDesc({ onClose, data }: IProps) {
    const fullHeight = useFullScreen();

    return (
        <StyledShowPopup {...{ fullHeight }} isConfirm={true} themeColor="red">
            <div className="page-wrapper">
                <div className="close" onClick={() => onClose()}>
                    <IConClose width={16} />
                </div>
                <div className="content-layout">
                    <div className="header-product">
                        <div className="layout-img">
                            <div className="img-product">
                                <img src={data.productImage} />
                            </div>
                        </div>
                        <div className="topic-product">{data.productName}</div>
                        <div className="desc-box ">
                            <div className="status">
                                {data.status === "ACCEPT"
                                    ? "รับสินค้าเข้าระบบ"
                                    : data.status === "VERIFY"
                                    ? "ตรวจสอบ"
                                    : data.status === "WAITING"
                                    ? "รอเบิกอะไหล่"
                                    : data.status === "FIXING"
                                    ? "กำลังซ่อม"
                                    : data.status === "FIXDONE"
                                    ? "งานซ่อมเสร็จ"
                                    : data.status === "APPROVE"
                                    ? "อนุมัติ"
                                    : ""}
                            </div>
                        </div>
                        <div className="color-box">
                            <div className="warranty-desc">
                                ไอดีการรับประกัน : {data.warrantyId} (หมดเขต:{" "}
                                {format(new Date(data?.expireWarrantyDate), "DD/MM/YYYY HH:mm")})
                            </div>
                            <div className="warranty-desc">เลขซีเรียล : {data.serialNumber}</div>
                        </div>
                        <Divider />
                        <div className="bottom-box">
                            <div className="text-desc">
                                วันที่ซื้อสินค้า :{" "}
                                {format(new Date(data?.purchaseDate), "DD/MM/YYYY")}
                            </div>
                            <div className="text-desc">
                                <span>
                                    <PinIcon />
                                </span>
                                {data?.store}, {data?.channel}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </StyledShowPopup>
    );
}
const StyledShowPopup = styled.div<{ isConfirm: boolean; themeColor: string; fullHeight: string }>`
    height: ${(p) => p.fullHeight};
    width: 100%;
    position: fixed;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);
    flex-direction: column;
    justify-content: end;
    tranisition: 2s !important;
    animation: opacity 0.5s !important;
    @keyframes opacity {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
    .page-wrapper {
        position: relative;
        width: 100%;
        .close {
            position: absolute;
            left: 18px;
            top: 18px;
            z-index: 1;
        }
    }
    .content-layout {
        height: auto;
        min-height: 50dvh;
        background-color: #fff;
        padding-top: 24px;
        padding-bottom: 24px;
        width: 100%;
        animation: bottomtotop 0.5s !important;
        position: relative;
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        text-align: center;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        }
        .content {
            background: transparent !important;
        }
        .header-product {
            margin-top: -100px;
            .layout-img {
                text-align: center;
                .img-product {
                    width: 141px;
                    height: 141px;
                    border-radius: 100%;
                    overflow: hidden;
                    margin: 0 auto 20px;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
            .topic-product {
                text-align: center;
                font-weight: 600;
                color: #000;
                font-size: 18px;
                margin-bottom: 5px;
            }
        }
        .desc-box {
            display: flex;
            width: 100%;
            align-items: center;
            text-align: center;
            justify-content: center;
            margin-bottom: 16px;
            .status {
                width: fit-content;
                padding: 1px 8px 2px 8px;
                gap: 10px;
                border-radius: 30px;
                background: rgba(38, 194, 164, 0.12);
                color: #26c2a4;
                font-size: 11px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                align-self: center;
            }
        }
        .color-box {
            display: flex;
            padding: var(--8-px, 8px) var(--0-px, 0px);
            flex-direction: column;
            align-items: flex-start;
            align-self: stretch;
            border: 0.5px dashed #ff5100;
            background-color: rgba(255, 81, 0, 0.12);
            align-items: center;
            .warranty-desc {
                color: #ff5100;
                text-align: center;
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: 20px;
            }
        }
        .bottom-box {
            display: flex;
            flex-direction: column;
            align-items: center;
            .text-desc {
                color: #9b9b9b;
                text-align: center;
                font-size: 10px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
            }
        }
    }
`;
